<style lang="less">
    .codeInput{
        position: relative;
        .input-box{
          // height: 51px;
          z-index:1000;
        }
        .input-sm-box{
          display: inline-block;
          font-size: 15px;
          margin: 0;
          text-align: center;
          display: inline-block;
          vertical-align: top;
          position: relative;
          span {
            font-size: 25px;
          }
          &:after{
            content: ' ';
            transform: scale(0.5);
            position: absolute;
            border-right: 1px solid rgb(237,237,237);
            border-top: 1px solid rgb(237,237,237);
            border-bottom: 1px solid rgb(237,237,237);
            top:-50%;
            right:-50%;
            bottom:-50%;
            left: -50%;
          }
        }
        .focus{
          border: 1px solid #3b99fc;
          border-radius: 3px;
          box-shadow: 0 0 3px 0 #3b99fc;
        }
        .input-sm-box:first-child {
          position relative
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
          &:after{
            content: ' ';
            transform: scale(0.5);
            position: absolute;
            border: 1px solid rgb(237,237,237);
            top:-50%;
            right:-50%;
            bottom:-50%;
            left: -50%;
          }
        }
        .input-sm-box:last-child{
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        }
        .box{
          position: relative;
          display: inline-block;
        }
        #invisibleInput{
          opacity: 0;
          width: 50px;
          position: absolute;
          color: transparent;
          top: -100px;

          transform: scale(0)
          // top: -1000000px;
          // left: -10000px;
        }
        .pwdPoint{
          display: inline;
          // width: 45px;
          text-align: center;
          border: none;
          font-size: 20px;
          // height: 45px;
          vertical-align: top;
        }
    }
</style>

<template>
  <div class="codeInput">
    <div class="input-box" :style="'height:'+inputBoxH">
      <div class="box" v-if="isPwd">
        <div :style="'width:'+width+';height:'+width+';line-height:'+width" class="input-sm-box" v-for="n in num" :key="n" @click="focusInput" >{{input[n-1]? input[n-1]: ' '}}</div>
      </div>

      <div class="box" v-else>
        <div :style="'width:'+width+';height:'+width+';line-height:'+width" class="input-sm-box" v-for="n in num" :key="n" @click="focusInput">
            <span v-if="input[n-1]">&bull;</span>
            <!-- <input :style="'width:'+pwdPoint+';height:'+pwdPoint" class='pwdPoint' v-if="input[n-1]" type='password' value='0'> -->
        </div>
      </div>

    </div>
    <!-- <input v-if="isPassword" type="tel" class="invisibleInput" ref="invisibleInput" :maxlength="num" v-model="inputResult" autofocus="autofocus" @keyup="setInput" @blur="blur" @focus="focusInput">
    <input v-else type="text" class="invisibleInput" ref="invisibleInput" :maxlength="num" v-model="inputResult" autofocus="autofocus" @keyup="setInput" @blur="blur" @focus="focusInput"> -->
    <input id="invisibleInput" ref="invisibleInput" :maxlength="num" v-model="inputResult" autofocus="autofocus"  @input="setInput" @blur="blur" @focus="focusInput" type="tel">
  </div>

</template>

<script>
  export default {
    props: ['isPassword','len', 'val','size'],
    data(){
      return {
        inputResult: '',
        input:[],
        width: (this.$props.size || "50")+'px'
      }
    },
    created: function(){
    },
    computed: {
      num: function () {
        return parseInt(this.$props.len)
      },
      isPwd: function () {
        if( this.isPassword == 0 ){
          return true
        }else{
          return false
        }
      },
      inputBoxH: function () {
        // console.log(this.$props.size + 1)
        const h = (parseInt(this.$props.size) + 1)+'px'
        // console.log(h)
        return h
      },
      pwdPoint: function () {
        const h = (parseInt(this.$props.size) - 5)+'px'
        return h
      }
    },
    watch: {
      
    },
    mounted() {
    },
    methods: {
      focusInput: function () {
        let el = document.getElementsByClassName('box')
        let invisibleInput = document.getElementById('invisibleInput')
        // let invisibleInput = this.$ref.invisibleInput
        if (typeof invisibleInput.selectionStart == "number") {
          invisibleInput.selectionStart = invisibleInput.selectionEnd = invisibleInput.value.length;
        } else if (typeof invisibleInput.createTextRange != "undefined") {
          invisibleInput.focus();
          var range = invisibleInput.createTextRange();
          range.collapse(false);
          range.select();
        }
        for(let i=0;i<el.length;i++){
          el[i].setAttribute("class", "focus box"); 
        }
        // var data = this.inputResult;
        // this.inputResult = "";
        this.$refs.invisibleInput.focus()
        // this.inputResult = data;
      },
      setInput: function () {
        this.input = this.inputResult.split('')
        this.$emit('code-value',this.inputResult)
      },
      reset: function () {
        this.inputResult = '';
        this.input = [];
      },
      blur: function () {
        let el = document.getElementsByClassName('box')
        for(let i=0;i<el.length;i++){
          el[i].setAttribute("class", "box"); 
        }
      }
    }
  }

</script>
